import { c as _c } from "react/compiler-runtime";
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import type { JSX } from 'react';
import { MenuContainer } from './container';
import { MenuItemDivider } from './divider';
import { MenuItemLink } from './link';
import { MenuItemTitle } from './title';
import { Tooltip } from '../../tooltip';
import { MenuItemType } from '../types';
import type { MenuItem } from '../types';
interface Props {
  items?: MenuItem[];
  children?: React.ReactNode;
  onItemClick?: () => unknown;
  testId?: string;
}
export function Menu(props) {
  const $ = _c(9);
  const {
    items,
    onItemClick,
    children,
    testId
  } = props;
  if (!children && !items) {
    throw new Error("Item or Children must be used.");
  }
  if (children) {
    let t0;
    if ($[0] !== children || $[1] !== onItemClick) {
      t0 = <MenuContainer onItemClick={onItemClick}>{children}</MenuContainer>;
      $[0] = children;
      $[1] = onItemClick;
      $[2] = t0;
    } else {
      t0 = $[2];
    }
    return t0;
  }
  let t0;
  if ($[3] !== items) {
    t0 = items?.map(_temp);
    $[3] = items;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== onItemClick || $[6] !== t0 || $[7] !== testId) {
    t1 = <MenuContainer onItemClick={onItemClick} testId={testId}>{t0}</MenuContainer>;
    $[5] = onItemClick;
    $[6] = t0;
    $[7] = testId;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}
function _temp(item, index) {
  if (item.type === MenuItemType.DIVIDER) {
    return <MenuItemDivider key={`divider-${index}`} />;
  }
  if (item.type === MenuItemType.TITLE) {
    const {
      title
    } = item;
    return <MenuItemTitle key={`${title}-${index}`}>{title}</MenuItemTitle>;
  }
  if (item.type === MenuItemType.LINK) {
    return <React.Fragment key={`${item.href ?? "-"}-${item.label}-${index}`}><Tooltip message={item.tooltip} positionTip={item.tooltipPosition}><MenuItemLink href={item.href || "#"} isDisabled={item.isDisabled} onClick={item.onClick} target={item.target} testId={item.testId}>{item.label}</MenuItemLink></Tooltip></React.Fragment>;
  }
  throw new Error("Invalid MenuItemType");
}